import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { GbkuhrechtService, GrundstueckId, QuoteKuhrechtMasterDetailEntry } from '../../../../core/gb-api';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { HistoryMode } from '../../../../core/services/HistoryMode';
import { AbstractComponent } from '../../../components/abstract-component/abstract.component';
import { ListLoader } from '../../../components/list-loader/list-loader';
import { ListLoaderObservable } from '../../../components/list-loader/list-loader-observable';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../../directives/history.directive';
import { KompaktTimepointComponent } from '../../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-kuhrecht',
  templateUrl: './kuhrecht.component.html',
  styleUrls: ['./kuhrecht.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    HistoryDirective,
    KompaktTimepointComponent,
    TranslatePipe
  ]
})
export class KuhrechtComponent extends AbstractComponent implements OnChanges, OnInit, OnDestroy {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<QuoteKuhrechtMasterDetailEntry>;
  hasPermissionSeybuch: boolean;
  historischeDatenSubscription;

  @Input()
  anzeigenHistorischeDaten = true;
  @Input()
  tableFullWidth = false;
  @Input()
  hasRight = true;

  constructor(
    private kuhrechtService: GbkuhrechtService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService,
    private appFormatConfigService: FormatConfigService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSub(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.hasPermissionSeybuch = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.SEYBUCH_FOLIO);
      })
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update() {
    const historischeDaten = this.anzeigenHistorischeDaten
      ? this.appConfigService.einstellungHistorischeDaten
      : HistoryMode.HistoryMode.OHNE_HIST;
    const timepointCtx = this.timepointService.timepointCtx;
    const observable = this.kuhrechtService.loadKuchrechtSichtGrundstueck(
      //
      this._grundstueckId.id, //
      timepointCtx.timepointIso, //
      timepointCtx.timepointId, //
      historischeDaten //
    );
    this.listLoader = new ListLoaderObservable<QuoteKuhrechtMasterDetailEntry>(undefined, 1, observable);
  }
}
